import { render, staticRenderFns } from "./HowToFindBook.vue?vue&type=template&id=9a0d2638&scoped=true"
import script from "./HowToFindBook.vue?vue&type=script&lang=js"
export * from "./HowToFindBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0d2638",
  null
  
)

export default component.exports